export default "__VITE_ASSET__DuUr5Ssb__"